import React, { useRef, useState,useEffect } from 'react';
import { Form, Row, Col, Card, Datepicker, Button, Modal, Table, CloseButton } from 'react-bootstrap';
import Icon from "../../controls/Icons/Icon";
import ErrorHandler from '../../controls/ErrorHandler';
import { ErrorBoundary } from 'react-error-boundary';
import { useSelector, useDispatch } from 'react-redux';
import DatePicker from "react-datepicker";
import { dateDisplayFormater, getDateSaveFormat } from '../../../Utils';
import DynamicDropdownSearchable from '../../controls/DynamicDropdownSearchable';
import DynamicDropdownSearchableForClient from '../../controls/DynamicDropdownSearchableForClient';
import { PCPAction } from '../../../Reducer/PCPReducer';
import useFetchWithCancellation from '../../../customhooks/useFetchWithCancellation';
import InvoicePayOutTransaction from './InvoicePayOutTransaction';
export default function InvoicePayOutUpdate({ rowData, afterSave }) {
    const [validated, setValidated] = useState(false);
    const formRef = useRef(null);
    const state = useSelector(state => state);
    const [isInvSelected, setisInvSelected] = useState(false);
    const [data, setData] = useState(null);
    const [invoiceDate, setinvoiceDate] = useState();
    const [IfPercent, setIfPercent] = useState(0);
    const [IfAmount, setIfAmount] = useState(0);
    const [OthersPercent, setOthersPercent] = useState(0);
    const [OthersAmount, setOthersAmount] = useState(0);
    const [ICCPercent, setICCPercent] = useState(0);
    const [ICCAmount, setICCAmount] = useState(0);
    const [PaymentDetails, setPaymentDetails] = useState("");
    const [paymentDate, setpaymentDate] = useState(new Date());
    const [modeofPayment, setmodeofPayment] = useState("");
    const [InvoiceOwnerId, setInvoiceOwnerId] = useState("");
    const [PayOutComments, setPayOutComments] = useState("");
    const dispatch = useDispatch();
    const { fetchData } = useFetchWithCancellation();
    const inputRef = useRef(null);
    const [BalPayOutAmt, setBalPayOutAmt] = useState(0);
    const [showTransactions, setshowTransactions] = useState(false);
   
    useEffect(() => {
        if (state.selPayUpdtData && state.selPayUpdtData.Id > 0) {
            console.log(state.selPayUpdtData);
            setData(state.selPayUpdtData);
            // console.log(date)
            // var invDate = new Date(state.selPayUpdtData.InvoiceDate);
            setinvoiceDate(state.selPayUpdtData.InvoiceDate);
            console.log(invoiceDate);
            setisInvSelected(true);
        } else {
            setisInvSelected(false);
        }
    }, []);

    const [savedata, setsavedata] = useState({
        fkinvoiceId:"",
        InvoiceNumber: "",
        InvoiceAmount: "",
        ReceivedAmount: "",
        IfPercent: "",
        ICCPercent: "",
        OthersPercent: "",
        PaymentDetails: "",
        ModeofPayment: "",
        paymentRecdDate: "",
        paymentDate: "",
        PayOutComments: "",
        PaidtoIFAmount: "",
        PayoutAmount: "",
        CreatedBy: JSON.parse(localStorage.getItem("user")).Id,
        ModifiedBy: JSON.parse(localStorage.getItem("user")).Id,
  
    });

    //useEffect(() => {
    //    setBalPayOutAmt(parseFloat(data.ReceivedAmount) - parseFloat(data.PaidtoIFAmount));
    //}, []);
    const handleModofPayment = (e) => {
        if (e.target.value !== '') {
            setmodeofPayment(e.target.value);
            setsavedata(c => ({ ...c, "ModeofPayment": e.target.value }));
        } else {

            window.alert("Please select the Mode of Payment");
            setmodeofPayment("");
            setsavedata(c => ({ ...c, "ModeofPayment": "" }));
            // e.target.value = '';
            e.target.focus();
            return false;
        }
    };

    const SaveData = () => {
        let TotPayOutAmt = parseFloat(data.PaidtoIFAmount)+ parseFloat(OthersAmount) + parseFloat(IfAmount) + parseFloat(ICCAmount);
        if (data.ReceivedAmount < TotPayOutAmt) {
            window.alert("Enter Amount is exceeding received Amount", function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
            //document.getElementById("IfPercent").focus();
            inputRef.current?.focus();
            return false;
        }
        

        savedata.ICCPercent = ICCPercent;
        savedata.IfPercent = IfPercent;
        savedata.OthersPercent = OthersPercent;
        savedata.ModeofPayment = modeofPayment;
        savedata.PaymentDetails= PaymentDetails;
        savedata.paymentDate = getDateSaveFormat(paymentDate);
        savedata.PayOutComments = PayOutComments;
        savedata.fkinvoiceId = data.Id;
        savedata.PayoutAmount = parseFloat(IfAmount) + parseFloat(ICCAmount) + parseFloat(OthersAmount);
       // savedata.InvoiceNumber = data.InvoiceNumber;
       // savedata.InvoiceAmount = data.InvoiceAmount;
        // savedata.ReceivedAmount = data.ReceivedAmount;
        if (savedata.ModeofPayment == "") {
            window.alert(" Please select Mode of Payment");
            return false;
        }

        if (savedata.PaymentDetails == "") {
            window.alert(" Please enter Payment details");
            return false;
        }
        let balPayOutAmt = parseFloat(data.ReceivedAmount) - parseFloat(data.PaidtoIFAmount);
        let totAmt = parseFloat(IfAmount) + parseFloat(OthersAmount) + parseFloat(ICCAmount);

        let updtStatus = "";
        if (totAmt >= balPayOutAmt) {
            updtStatus = "Fully Settled";
        } 
        if (totAmt < balPayOutAmt) {
            updtStatus = "Partially Settled"; //Partially Settled
            }
        
        //if (data.ReceivedAmount < data.InvoiceAmount) {
        //    updtStatus = "Partial Payment Recd";
        //}
        fetchData(state.projectdetail.API + "/invoice/SavePayOut?status=" + updtStatus, {
            method: "POST",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(savedata)
        }).then(response => response.json()).then((res) => {
            if (res.Succeeded) {
                setsavedata(res);
                window.toast("Invoice Payout saved sucessfully");
                setValidated(false);
                // setSavedSuccessfully(true);
                //  let savedstatus = true;
                // afterSave(savedstatus);
               // afterSave(true);
            }
            else {
                window.alert(res.Message, function () { }, <Icon name='BsFillEmojiFrownFill' />, "Ok", "danger");
            }
        }).catch((err) => {
            if (err && err.name === 'AbortError') return;
            window.HandleError("Invoice Payout.js ==> client save", null, null, err);
            window.alert(state.projectdetail.ErrorMessage);
        }).finally(() => {
            afterSave(true);
        });
        
    } 
    const handleCancel = () => {
        setIfPercent(0);
        setIfAmount(0);
        setOthersPercent(0);    
        setOthersAmount(0);
        setICCAmount(0);
        setICCPercent(0);
        setmodeofPayment("");
        setPaymentDetails("");
        inputRef.current?.focus();
    }

    const handleChangeAmt = (e) => {
        const name = e.target.name;
        let value = e.target.value;
        let maxLength = e.target.maxLength;
        if (isNaN(value)) {
            e.target.value = 0;
            e.target.focus();
            return false;
        }

        if (name === "IfAmount") setIfAmount(value);
        if (name === "OthersAmount") setOthersAmount(value);
        if (name === "ICCAmount") setICCAmount(value);

    }

    const handleChange = (e)=>{
        const name = e.target.name;
        let value = e.target.value;
        let maxLength = e.target.maxLength;
        if (isNaN(value)) {
            e.target.value = 0;
            e.target.focus();
            return false;
        }
        if (value >= 100) {
            e.target.focus();
            window.alert("Enter valid percentage value");
        }
        if (name === "IfPercent") setIfPercent(value);
        if (name === "OthersPercent") setOthersPercent(value);
        if (name === "ICCPercent") setICCPercent(value);

    }
    
    const handleIfPercent = (e) => {
        let value = e.target.value;
        let name = e.target.name;
        let balPayOutAmt = parseFloat(data.ReceivedAmount) - parseFloat(data.PaidtoIFAmount);
        let totAmt = parseFloat(IfAmount) + parseFloat(OthersAmount) + parseFloat(ICCAmount);
        // if (totAmt > data.ReceivedAmount) {
        if (totAmt > balPayOutAmt) {
            e.target.focus();
            window.alert("Over all Amount is exceeding received Amount");
        }

        if (value < balPayOutAmt) {
            let percent = ((value / balPayOutAmt) * 100);
            if (name == "IfAmount") setIfPercent(percent);
            if (name == "OthersAmount") setOthersPercent(percent);
            if (name == "ICCAmount") setICCPercent(percent);
        } else {
            e.target.focus();
            window.alert("Entered Amount is exceeding received Amount");
        }

       
    }

    const handleIfAmount = (e) => {
        let value = e.target.value;
        let name = e.target.name;
        let balPayOutAmt = parseFloat(data.ReceivedAmount) - parseFloat(data.PaidtoIFAmount);
        let totPercent = parseFloat(IfPercent) + parseFloat(OthersPercent) + parseFloat(ICCPercent);
        if (totPercent > 100) {
            e.target.focus();
            window.alert("Over all percentage is exceeding 100 %");
        }
        if (value < 100) {
            let percentAmt = ((value / 100) * balPayOutAmt).toFixed(2);
            if (name == "IfPercent") setIfAmount(percentAmt);
            if (name == "OthersPercent") setOthersAmount(percentAmt);
            if (name == "ICCPercent") setICCAmount(percentAmt);
        }
    }
    const handlePayDetChange = (e) => {
        setPaymentDetails(e.target.value);
    }
    const handlePaymentDet = (e) => {
        setPaymentDetails(e.target.value);
    }
    const handlePayCommentChange = (e) => {
        setPayOutComments(e.target.value);
    }

    const handlePayOutComment = (e) => {
        setPayOutComments(e.target.value);
    }

    const viewTransactions = () => {
        setshowTransactions(true);

    }
    const CloseTransactions = () => {
        setshowTransactions(false);
    }
    const handleInvOwner = (e) => {
        setInvoiceOwnerId(e.target.value);
        setData(data => ({ ...data, InvoiceOwner: e.target.options[e.target.selectedIndex].text, InvoiceOwnerId: e.target.value }));
        // console.log(InvoiceOwnerId);
        dispatch({ type: PCPAction.SetPCPHasUnsavedChanges, payload: true });
    }
    return (<ErrorBoundary FallbackComponent={ErrorHandler}>
        <Form noValidate validated={validated} ref={formRef}>
            <div>
                <div>
                    Payment Update Screen
                    {!isInvSelected &&
                        <div>Please select invoice for update the payment</div>
                    }
                    {isInvSelected &&
                        <div> 
                            
                            <Card className="border">
                                <Card.Body>
                                    <Row>
                                        <Col md={2}>
                                            Inv.Number
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group>
                                                <Form.Control type="text" name="InvoiceNumber" value={data.InvoiceNumber} disabled autoComplete="off" />
                                            </Form.Group>
                                        </Col>
                                        <Col md={1}>
                                           
                                        </Col>
                                        <Col md={2}>
                                            Inv.Amount
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Control type="text" name="InvoiceAmount" value={data.InvoiceAmount} disabled autoComplete="off" />
                                            </Form.Group>
                                        </Col>
                                        {/*<Col md={5}>*/}
                                        {/*    <Form.Group>*/}
                                        {/*        <Form.Label>Invoice Date<code className='required-symbol'>*</code></Form.Label>*/}
                                        {/*        <DatePicker required={true} className="form-control" selected={new Date(state.selPayUpdtData?.InvoiceDate)} disabled*/}
                                        {/*        //onChange={(val) => (handleDatePickerChange(val, "InvoiceDate"))}*/}
                                        {/*            showYearDropdown*/}
                                        {/*            showMonthDropdown*/}
                                        {/*            dateFormat="MM-dd-yyyy"*/}
                                        {/*        />*/}
                                                
                                        {/*    </Form.Group>*/}
                                        {/*</Col>*/}
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col md={2}>
                                            Paid PayOut Amt
                                        </Col>
                                        <Col md={3}>
                                            <Form.Group>
                                                <Form.Control type="text" name="PaidtoIFAmount" value={data.PaidtoIFAmount} disabled autoComplete="off" />
                                            </Form.Group>
                                        </Col>
                                        <Col md={1}>

                                        </Col>
                                        <Col md={2}>
                                            Recd.Amt
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Control type="text" name="ReceivedAmount" value={data.ReceivedAmount} disabled autoComplete="off" />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col md={2}>
                                            
                                        </Col>
                                        <Col md={2}>
                                            <p style={{align:'center'}} >%</p> 
                                        </Col>
                                        <Col md={2}>
                                            <p style={{ align: 'center' }} >Amount</p> 
                                        </Col>
                                        <Col md={2}>
                                            Payment Date
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <DatePicker required={true} className="form-control" selected={paymentDate} onChange={(date) => setpaymentDate(date)}
                                                    showYearDropdown
                                                    showMonthDropdown
                                                    dateFormat="MM-dd-yyyy"
                                                />
                                            </Form.Group>
                                        </Col>

                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col md={2}>
                                        IF
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Control type="text" ref={inputRef} name="IfPercent" onChange={(e) => { handleChange(e) }} onBlur={(e) => { handleIfAmount(e) }} value={IfPercent} autoComplete="off" />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Control type="text" name="IfAmount" onChange={(e) => { handleChangeAmt(e) }} onBlur={(e) => { handleIfPercent(e) }}  value={IfAmount}  autoComplete="off" />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            Payment Mode
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Select
                                                    as="select"
                                                    value={modeofPayment}
                                                    onChange={handleModofPayment}
                                                >
                                                    <option value="">Select Mode of Payment</option>
                                                    <option value="Account Transfer">Account Transfer</option>
                                                    <option value="Cheque">Cheque</option>
                                                    <option value="Zelle">Zelle</option>
                                                </Form.Select>
                                            </Form.Group>
                                        </Col>

                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col md={2}>
                                            ICC
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Control type="text" name="ICCPercent" onChange={(e) => { handleChange(e) }} onBlur={(e) => { handleIfAmount(e) }} value={ICCPercent} autoComplete="off" />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Control type="text" name="ICCAmount" onChange={(e) => { handleChangeAmt(e) }} onBlur={(e) => { handleIfPercent(e) }} value={ICCAmount}  autoComplete="off" />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            Payment to
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <DynamicDropdownSearchableForClient
                                                    from={state.projectdetail.API + "/User/GetAllActiveUsers"}
                                                    label="name"
                                                    value="Id"
                                                    fetchType="get"
                                                    name="name"
                                                    id="name"
                                                    onDropdownChange={handleInvOwner}
                                                    defaultval={data.InvoiceOwnerId}
                                                />

                                            </Form.Group>
                                        </Col>
                                        
                                    </Row>
                                    <Row> &nbsp;</Row>
                                    <Row>
                                        <Col md={2}>
                                            Others
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Control type="text" name="OthersPercent" onChange={(e) => { handleChange(e) }} onBlur={(e) => { handleIfAmount(e) }} value={OthersPercent} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            <Form.Group>
                                                <Form.Control type="text" name="OthersAmount" value={OthersAmount} onChange={(e) => { handleChangeAmt(e) }} onBlur={(e) => { handleIfPercent(e) }} />
                                            </Form.Group>
                                        </Col>
                                        <Col md={2}>
                                            Details
                                        </Col>
                                        <Col md={4}>
                                            <Form.Group>
                                                <Form.Group>
                                                    <Form.Control as="textarea" rows={3} name="PaymentDetails" value={PaymentDetails} onChange={(e) => { handlePayDetChange(e) }} onBlur={(e) => { handlePaymentDet(e) }} autoComplete="off" />
                                                </Form.Group>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col md={2}>
                                            Comments
                                        </Col>
                                        <Col md={10}>
                                            <Form.Group>
                                                <Form.Control as="textarea" rows={4} name="PayOutComments" value={PayOutComments} onChange={(e) => { handlePayCommentChange(e) }} onBlur={(e) => { handlePayOutComment(e)}} autoComplete="off" />
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                    {/*<Row>&nbsp;</Row>*/}
                                    {/*<Row>*/}
                                    {/*    <Col md={12}>*/}
                                    {/*        <Table>*/}
                                    {/*            <thead>*/}
                                    {/*                <th>S.No</th>*/}
                                    {/*                <th>Client Name</th>*/}
                                    {/*                <th>Invoice Number</th>*/}
                                    {/*                <th>Invoice Date</th>*/}
                                    {/*                <th>Invoice Amount</th>*/}
                                    {/*                <th>Received Amount</th>*/}
                                    {/*                <th>Payment Notes</th>*/}
                                    {/*            </thead>*/}
                                    {/*            <tr>*/}
                                    {/*                <td>1</td>*/}
                                    {/*                <td>{data.ClientName}</td>*/}
                                    {/*                <td>{data.InvoiceNumber}</td>*/}
                                    {/*                <td>{dateDisplayFormater(data.InvoiceDate)}</td>*/}
                                    {/*                <td>{data.InvoiceAmount}</td>*/}
                                    {/*                <td>{data.ReceivedAmount}</td>*/}
                                    {/*                <td>{PaymentDetails}</td>*/}

                                    {/*            </tr>*/}

                                    {/*        </Table>*/}


                                    {/*    </Col>*/}
                                    {/*</Row>*/}
                                    <Row>&nbsp;</Row>
                                    <Row>
                                        <Col md={5}></Col>
                                        {/*<Col md={1}>*/}
                                        {/*    <Button type="button" id="Save" name="Save" onClick={SaveData} className="me-2" variant="primary">Save</Button>*/}
                                        {/*</Col>*/}
                                        {/*<Col md={2}>*/}
                                        {/*    <Button type="button" onClick={handleCancel} className="me-2" variant="primary">Cancel</Button>*/}
                                        {/*</Col>*/}
                                        <Col md={7}>
                                            <Form.Group>
                                                <Button type="button" id="Transactions" name="Transactions" style={{ align: 'right' }} onClick={viewTransactions} className="me-2" variant="primary">View Transactions</Button>
                                                &nbsp;&nbsp;&nbsp;
                                                <Button type="button" id="Save" name="Save" style={{align:'right'}} onClick={SaveData} className="me-2" variant="primary">Save</Button>
                                                &nbsp;&nbsp;&nbsp;
                                                <Button type="button" onClick={handleCancel} className="me-2" variant="primary">Cancel</Button>
                                            </Form.Group>
                                        </Col>
                                    </Row>
                                </Card.Body>
                            </Card>

                            <Modal size="lg" show={showTransactions} onHide={CloseTransactions} backdrop="static">
                                <Modal.Header style={{ background: "#0a4081", color: "white" }} dialogClassName="custom-modal-position">
                                    <h4>Pay out Transactions</h4>
                                    <CloseButton onClick={CloseTransactions} className="btn-close" />
                                </Modal.Header>
                                <Modal.Body>
                                    <InvoicePayOutTransaction invId={data.fkinvoiceId}  onCancel={CloseTransactions} />
                                </Modal.Body>
                            </Modal>
                        </div>
                    }
                </div>
            </div>
        </Form>
    </ErrorBoundary>
    );
};